import React, { memo } from "react";
import {
  Stack,
  Card,
  Box,
  Typography,
  TextField,
  Avatar,
  CardContent,
  Divider,
  Button,
  InputBase,
} from "investira.react.components";

import mastercardLogo from "../../assets/images/mastercard-logo.png";

import { PageTemplate } from "../../components/templates";

const PagamentosAssinaturas = memo(() => {
  return (
    <Stack sx={{ width: "70%", margin: "0 auto" }}>
      <PageTemplate title="Pagamentos e Assinaturas">
        <Box component="form" noValidate>
          <Stack spacing={3}>
            <Stack>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="textPrimary" gutterBottom>
                    Assinatura
                  </Typography>

                  <Stack spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Stack sx={{ width: "120px" }}>
                        <Typography variant="caption" color="textPrimary">
                          Plano
                        </Typography>
                      </Stack>
                      <Stack flexGrow={1}>
                        <Typography variant="body1" color="textPrimary">
                          Pacote 12
                        </Typography>
                      </Stack>
                      <Stack>
                        <Button color="primary" size="small">
                          Mudar Plano
                        </Button>
                      </Stack>
                    </Stack>
                    <Divider />
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
            <Stack>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="textPrimary" gutterBottom>
                    Pagamento
                  </Typography>

                  <Stack spacing={1}>
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Stack sx={{ width: "120px" }}>
                        <Typography variant="caption" color="textPrimary">
                          Método
                        </Typography>
                      </Stack>
                      <Stack flexGrow={1}>
                        <Typography variant="caption" color="textPrimary">
                          Cartão de Crédito
                        </Typography>
                      </Stack>
                      <Stack>
                        <Button color="primary" size="small">
                          Mudar Método
                        </Button>
                      </Stack>
                    </Stack>
                    <Divider />
                    <Stack direction="row" spacing={2} alignItems="center">
                      <Stack sx={{ width: "120px" }}>
                        <Typography variant="caption" color="textPrimary">
                          Número do cartão
                        </Typography>
                      </Stack>
                      <Stack flexGrow={1}>
                        <InputBase
                          id="credit"
                          name="credit"
                          placeholder="1234 5678 9012 3456"
                        />
                        <Typography variant="body1" color="textPrimary">
                          1234 5678 9012 3456
                        </Typography>
                      </Stack>
                      <Stack>
                        <img src={mastercardLogo} width={20} />
                      </Stack>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
          </Stack>
        </Box>
      </PageTemplate>
    </Stack>
  );
});

export default PagamentosAssinaturas;
